import { BasePageModel, basePageToLocal } from './base';
import {
  ReferenceNode,
  Reference,
  referenceNodeToLocal,
  referenceNodeToServer
} from './parameter';


export interface FrameMappingUpdateFuncArgumentConfig {
  nextFrameMappings?: FrameMapping[];
  nextDelFrameMappings?: FrameMapping[];
  nextDelFrameMapping?: FrameMapping;
  nextRevertFrameMappingId?: string;
}


export enum ConversionMode {
  Label = 'label',
  Expression = 'expression'
}

export type FrameMappingContent = {
  targetSlot?: ReferenceNode;
  mappingSlot?: ReferenceNode;
  conversionMode: ConversionMode;
};


export type FrameMapping = BasePageModel & {
  targetFrame?: ReferenceNode;
  contents: FrameMappingContent[];

  // for local use
  dirty?: boolean;
};

export function frameMappingContentToLocal(res: any) {
  return {
    targetSlot: res.target_slot && referenceNodeToLocal(res.target_slot),
    mappingSlot: res.mapping_slot && referenceNodeToLocal(res.mapping_slot),
    conversionMode: res.conversion_mode || ConversionMode.Label
  };
}
export function frameMappingContentToServer(res: FrameMappingContent) {
  return {
    target_slot: res.targetSlot && referenceNodeToServer(res.targetSlot),
    mapping_slot: res.mappingSlot && referenceNodeToServer(res.mappingSlot),
    conversion_mode: res.conversionMode || ConversionMode.Label
  };
}
export function frameMappingToLocal(res: any): FrameMapping {

  return {
    ...basePageToLocal(res),
    targetFrame: res.target_frame && referenceNodeToLocal(res.target_frame),
    contents: res.contents && res.contents.map(frameMappingContentToLocal) || []
  };
}


export function frameMappingToServer(data: FrameMapping): any {

  return {
    id: data.id,
    owner_id: data.ownerId,
    target_frame: data.targetFrame && referenceNodeToServer(data.targetFrame),
    contents: data.contents && data.contents.map(frameMappingContentToServer) || []
  };
}
